import { focusFirst, initFields, resetValidations, resetValues } from '@/utils/form';

export default {
  data() {
    return {
      form: initFields({
        name: 'otp',
      }),
      isBusy: false,
      isOtpResendDisabled: false,
    };
  },

  methods: {
    async onResendOtp() {
      try {
        this.isBusy = true;
        await this.proxy.otpResend();
        resetValues(this.form);
        resetValidations(this.form);
        focusFirst(this.form);
      } catch (error) {
        const code = error?.data?.code;
        if (code === 'OTP_RESEND_LIMIT_EXCEEDED') {
          this.isOtpResendDisabled = true;
        } else {
          throw error;
        }
      } finally {
        this.isBusy = false;
      }
      this.$webtrekk.link('cita.label_request_new_code');
    },
  },
};
